import "./ProgressBar.css";
interface ProgressBarProps {
  progress?: number;
  width?: string;
}

export const ProgressBar = ({ progress = 0, width = '100px', ...props }: ProgressBarProps) => {
  const variantStyle = { width: `${progress}%` }
  return (
    <div className={"progress-bar "} style={{ width: `${width}` }}>
      <div style={variantStyle} className="progress-bar-line"></div>
    </div>
  );
};
